import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import cx from 'classnames'

import content from 'prismic-translates/common.json'
import { useAppSelector } from 'src/store/hooks'
import { getUserSelector } from 'store/modules/user/selectors'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

function AccountIdMessage() {
  const userInfo = useAppSelector(getUserSelector)

  if (userInfo) {
    const { customerId } = userInfo

    return (
      <>
        {userInfo?.admin && <div className={cx('mt-typography-body2', classes.root)}>{t('admin_user')}</div>}

        <div className={cx('mt-typography-body2', classes.root)} data-test='menu-account-id'>
          {t('customer_id')}: {customerId}
        </div>
      </>
    )
  }

  return null
}

export default AccountIdMessage
